<ng-container [formGroup]="formGroup">
  <ta-button-group uniform formControlName="mode">
    <ta-button-option value="Tree">Tree</ta-button-option>
    <ta-button-option value="Text">Text</ta-button-option>
  </ta-button-group>

  <div class="pv--6">
    <div *ngIf="mode?.value === EditorMode.Text">
      <ta-json-text-editor formControlName="tree"></ta-json-text-editor>
    </div>

    <div *ngIf="mode?.value === EditorMode.Tree">
      <ta-flexbox class="pb--2">
        <ta-button icon class="mr--2" (click)="expandAll()"
          ><ta-icon icon="resize-full"></ta-icon
        ></ta-button>
        <ta-button icon (click)="collapseAll()"
          ><ta-icon icon="resize-small"></ta-icon
        ></ta-button>
      </ta-flexbox>

      <ta-json-object-editor
        *ngIf="rootType === FieldType.Object"
        formControlName="tree"
        [rootName]="rootName"
        [animate]="animate"
      ></ta-json-object-editor>

      <ta-json-array-editor
        *ngIf="rootType === FieldType.Array"
        formControlName="tree"
        [rootName]="rootName"
        [animate]="animate"
      ></ta-json-array-editor>
    </div>
  </div>
</ng-container>
